// Parse a class-variable rule into selector/body components.
export function parseClassVariableRule(value: string): { selector: string; body: string } | null {
  // Regex captures selector and body from `selector { ... }` patterns.
  const match = value.match(/^\s*([^{}]+?)\s*\{([\s\S]*)\}\s*;?\s*$/);
  // Return null when value does not look like a CSS rule block.
  if (!match) {
    return null;
  }

  const [, selector, body] = match;
  return {
    selector: selector.trim(),
    body,
  };
}

// Merge base selector and addon selector into one concrete selector.
export function combineSelector(baseSelector: string, addonSelector: string): string {
  const base = baseSelector.trim();
  const addon = addonSelector.trim();

  // Expand explicit '&' placeholders with the provided base selector.
  if (addon.startsWith("&")) {
    return addon.replace(/&/g, base);
  }

  // Append direct selector suffixes like :hover, .class, #id, or [attr].
  if (
    addon.startsWith(":") ||
    addon.startsWith("::") ||
    addon.startsWith("[") ||
    addon.startsWith(".") ||
    addon.startsWith("#")
  ) {
    return `${base}${addon}`;
  }

  // Fallback: treat addon as descendant selector.
  return `${base} ${addon}`;
}
